import { mutate } from "swr";

export async function fetchCountry(
    i18nextLng: string,
    setCountryOptions: Function,
    t: any,
    fetchGlobal: <T>(url: string, options?: RequestInit) => Promise<T>
) {
    let apiUrl = `${process.env.REACT_APP_API_V2_URL}/settings/pays`;
    try {
        const data = await fetchGlobal<any>(apiUrl, {
            headers: {
                "Content-Type": "application/json",
                "Accept-Language": i18nextLng,
            },
            method: "GET",
        });

        if (data.error) {
            throw Error("Error!");
        }

        let listOfCountry: any = [];
        data.data.forEach((element: any) => {
            listOfCountry.push({
                label: element["Designation"],
                value: element.Id,
                code: element[t("code")],
            });
        });
        setCountryOptions(listOfCountry);

        mutate(apiUrl, data);
    } catch (e: any) {}
}
